import { Dialog, DialogContent } from '@mui/material';
import React, { useState } from 'react'
import clientServices from '../clientServices';
import moment from 'moment';
import ClientForm from './ClientForm';
import { Add, DoubleArrow, PersonAddAlt1 } from '@mui/icons-material';

function ClientSearchComponent({setClientId}) {

    
    
    const [inputClientId,setInputClientId] = useState("");
    const [dialogStatus,setDialogStatus]     =  useState(false);
    const [inputPhoneNo,setInputPhoneNo] = useState("");
    const [searchList,setSearchList] = useState(null);

    


    const handlePatintIdKeydown = (e) =>{
        if (e.key === 'Enter') {
            console.log('do validate');
            setClientId(inputClientId);
        }
    }

    const searchByPhoneNo = () =>{
        clientServices.searchByPhone(inputPhoneNo).then(res=>{
            setSearchList(res.data);
        }).catch(error=>{
        })
    }

    const searchSelect = (id) =>{
        setInputClientId(id);
        setClientId(id);
        setDialogStatus(false);
    }

    const handlePatintPhoneNoKeydown = (e) =>{
        if (e.key === 'Enter') {
            console.log('do validate');
            searchByPhoneNo();
        }
    }

    // Add Client Form 
    const addClientSuccess = (res) =>{
        if(res.id !== undefined){ //new Client Created
            setInputClientId(res.id);
            setClientId(res.id)
            searchByPhoneNo();
            setDialogStatus(false);
        } else {
            setClientId(inputClientId)
        } 
    }

    return (
        <>
            <div className='row'>
                <div className='col-md-6'>
                    <div className="form-floating mt-2">
                        <input type="text" className="form-control"
                            value={inputClientId} onChange={(e)=>{setInputClientId(e.target.value)}} onKeyDown={handlePatintIdKeydown}
                        />
                        <label>Search Client ID</label>
                    </div>
                </div>
                <div className='col-md-6 p-2 text-center'>
                    <span className='fw-bold'>OR</span> <button className='mx-2 btn btn-primary' onClick={()=>setDialogStatus(true)}><PersonAddAlt1/> Add New</button>
                </div>
            </div>

                <Dialog
                        open={dialogStatus}
                        keepMounted
                        onClose={()=>{setDialogStatus(false)}}
                        fullWidth={true}
                        maxWidth="md"
                >
                    <DialogContent >
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className="form-floating">
                                    <input type="text" className="form-control"
                                        value={inputPhoneNo} onChange={(e)=>{setInputPhoneNo(e.target.value)}}
                                        onKeyDown={handlePatintPhoneNoKeydown}
                                    />
                                    <label >Enter PhoneNo </label>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <button className='btn btn-primary btn-lg' onClick={searchByPhoneNo} ><DoubleArrow/></button>
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-md-12'>
                                {searchList && searchList.length > 0 &&
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                {/*<th>S/O, D/O, W/O</th> */}
                                                <th>Client ID</th>
                                                <th>User Since</th>
                                                <th>Last Upadate</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {searchList.map(client =>
                                                <tr onClick={()=>searchSelect(client.id)} >
                                                    <td>{client.firstName} {client.lastName}</td>
                                                    {/*<td>{client.careOf}</td> */}
                                                    <td>P-{client.id}</td>
                                                    <td>{ moment(client.created_at).format("ll") }</td>
                                                    <td>{ moment(client.updated_at).format("ll") }</td>
                                                </tr>
                                            )}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan={4} className='text-center'>
                                                    <ClientForm onSuccess={addClientSuccess} />
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                }
                                {searchList && searchList.length == 0 &&
                                    <div className='text-center'>
                                        <div className=" text-danger m-2 fw-bold">No Record Found </div>
                                        <ClientForm onSuccess={addClientSuccess} />
                                    </div>
                                }
                            </div>
                        </div>
                    </DialogContent>

                </Dialog>
        </>
    )
}

export default ClientSearchComponent